import { AdminGrant, SharedUserGrants, UserGrantMutable } from '../../controllers/auth/types';
import { DataCollectionAccountWithSettings } from '../../controllers/subscription-service/types';

export type RequiredGrants = {
  org: (UserGrantMutable | SharedUserGrants)[],
  zero: AdminGrant[],
};

export interface DataCollectionConfig<OfferedSubscriptionId extends string> {
  offeredSubscriptionEnum: Record<string, OfferedSubscriptionId>;
  visibleOfferedSubscriptions: ReadonlyArray<OfferedSubscriptionId>
  subscriptionQueryTranslations: Readonly<
  Partial<Record<OfferedSubscriptionId, Record<string, string>>>
  >,
  SubscriptionSettingUniqueValues: Readonly<Partial<Record<OfferedSubscriptionId, string[]>>>,
  disableAccountNameEntry: ReadonlyArray<OfferedSubscriptionId>,
  authorize: (dca: DataCollectionAccountWithSettings) => undefined | void | Error,
  isConfig: (dca: DataCollectionAccountWithSettings) => boolean,
  hasRequiredSettings: (dca: DataCollectionAccountWithSettings) => boolean,
  dcaInstructionsComponent: Record<OfferedSubscriptionId, React.FC | JSX.Element>,
  requiredGrants: RequiredGrants
}

/* istanbul ignore next */
export default function createDataCollectionConfig<
  OfferedSubscriptionId extends string,
>(
  offeredSubscriptionEnum: Record<string, OfferedSubscriptionId>,
  visibleOfferedSubscriptions: ReadonlyArray<OfferedSubscriptionId>,
  subscriptionQueryTranslations: Readonly<
  Partial<Record<OfferedSubscriptionId, Record<string, string>>>
  >,
  SubscriptionSettingUniqueValues: Readonly<Partial<Record<OfferedSubscriptionId, string[]>>>,
  disableAccountNameEntry: ReadonlyArray<OfferedSubscriptionId>,
  authorize: (dca: DataCollectionAccountWithSettings) => undefined | void | Error,
  isConfig: (dca: DataCollectionAccountWithSettings) => boolean,
  hasRequiredSettings: (dca: DataCollectionAccountWithSettings) => boolean,
  dcaInstructionsComponent: Record<OfferedSubscriptionId, React.FC | JSX.Element>,
  requiredGrants: RequiredGrants,
): DataCollectionConfig<OfferedSubscriptionId> {
  return {
    offeredSubscriptionEnum,
    visibleOfferedSubscriptions,
    subscriptionQueryTranslations,
    SubscriptionSettingUniqueValues,
    disableAccountNameEntry,
    authorize,
    isConfig,
    hasRequiredSettings,
    dcaInstructionsComponent,
    requiredGrants,
  };
}
